import { Vue, prop, Options } from 'vue-class-component';
import VueSlider from 'vue-slider-component';
import { WidgetWrapper } from '@/components/widget-wrapper';
import '@/styles/slider.scss';
import { Inject, Watch } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { Routes } from '@/router/routes';
import { WriteupModuleContext } from '@/store/writeup';
import { Button, ButtonTypes } from '@/components/button';
import { ServiceContainer } from '@/services';
import { CoreModuleContext } from '@/store/core';
import { TealiumLink, TealiumPage } from '@/types/tealium-events';
import styles from './styles.module.scss';

class TradeInSliderProps {
	loading = prop<boolean>({ default: true })

	value = prop<number>({ default: 0 })

	min = prop<number>({ default: 0 })

	max = prop<number>({ default: 1000 })

	step = prop<number>({ default: undefined })

	onChange = prop<Function>({ default: () => () => undefined })

	disabled = prop<boolean>({ default: false })
}

@Options({
	components: {
		VueSlider,
	},
})
export class TradeInSlider extends Vue.with(TradeInSliderProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	@Inject() readonly coreModule!: CoreModuleContext;

	@Inject() readonly services!: ServiceContainer;

	get writeup() { return this.writeupModule.getters.writeupObject; }

	sliderValue = this.value;

	@Watch('value')
	updateValue(value: number): void {
		this.sliderValue = value;
	}

	@Watch('sliderValue')
	handleSliderValueChange(value: number) {
		this.onChange(value);
	}

	async triggerTealium() {
		await this.writeupModule.actions.updateTealiumDataLayer(
			{
				pageMapping: TealiumPage.CustomizeDeal,
				linkMapping: TealiumLink.TradeIn,
			}
		);
	}

	triggerEvent() {
		const eventData = {
			Label: 'TradeIn',
			Action: 'TradeInStart',
			...this.$route.meta,
		};

		this.services.amplitude.sendEvent(eventData);
	}

	render() {
		return (
			<WidgetWrapper
				class={ styles.tradeInSlider }
				active={ this.sliderValue !== 0 }
				loading={ this.loading }
				title={ this.i18n.t('tradeInSlider.title') }
				value={ this.sliderValue < 0 ? `(${this.i18n.n(Math.abs(this.sliderValue), 'currency')})` : this.i18n.n(this.sliderValue, 'currency')}
				editIcon={true}
				unFormattedValue={this.sliderValue}
				onChange={this.updateValue}
				inputPrefix={'$'}
				min={this.min}
				max={this.max}
				isScoreUpdated={this.disabled}
			>
				<div v-show={ this.disabled } class={ styles.tradeInSliderSubtitle }>
					{ this?.writeup?.tradeIn?.make } { this?.writeup?.tradeIn?.model } { this?.writeup?.tradeIn?.trim }
				</div>

				<div v-show={ !this.disabled } class={ styles.tradeInSliderSubtitle }>
					{ this.i18n.t('tradeInSlider.description') }
				</div>

				<vue-slider class={ styles.tradeInSliderSlider } v-model={ this.sliderValue } min={ this.min }
					max={ this.max } interval={ this.step } disabled={ this.disabled }
					dotSize={ 24 } tooltip={ 'none' } silent={ true }
				/>
				<Button type={ ButtonTypes.link } to={ Routes.TRADE_IN.path } onClick={ this.triggerTealium } fullWidth>{ this.i18n.t('tradeInSlider.helpMe')}</Button>
			</WidgetWrapper>
		);
	}
}
